import { mapGetters } from "vuex";
import { bus } from "../main";
import axios from "axios";
import templateBuilderHelper from "./templateBuilderHelper";
import { fetchEntityById } from "@/repo/entityRepo";
import { postAPICall } from "@/helpers/httpHelper";
import entityRelationshipMixin from "@/mixins/entityRelationshipMixin";
export default {
  mixins: [templateBuilderHelper, entityRelationshipMixin],
  data() {
    return {
      allTemplatesData: {},
      nonCompletedUserValues: [],
      notCompletedUsers: [],
      allUsersRepeatableDataKeys: {},
      repeatableIndexKeys: {},
      entityPrimaryData: {},
      getPrimaryTitle: "",
    };
  },
  computed: {
    isPageInEntityGroups() {
      return this.$route.path.indexOf("entity-groups") > -1;
    },
    ...mapGetters("entities", [
      "getEntityDataByQuery",
      "getEntitiesDataByQuery",
      "getCompanyEntityDetails",
      "getEntityPrimaryData",
      "getChildEntityDataById",
    ]),
    ...mapGetters("templatesData", [
      "getTemplatesData",
      "getRepeatableTemplateIds",
      "getAddNewRepeatableDataStatus",
      "getAddNewRepeatableData",
      "getAddNewRepeatableDataErrors",
    ]),
    checkPrimaryFieldsFilled() {
      if (this.newRepeatableData && this.newRepeatableTemplateData) {
        let isFilled = false;
        this.newRepeatableTemplateData.forEach((e) => {
          if (e && e.is_primary && !this.newRepeatableData[e.key]) {
            isFilled = true;
          }
        });
        return isFilled;
      }
      return true;
    },
  },
  methods: {
    //mapping fields with latest field type
    quickUpdateFieldDisabled(template_id, key, entity) {
      let field = entity?.templates
        ?.find((e) => e?.templateInfo._id == template_id)
        .templateInfo.sections[0]?.fields?.find((e) => e.key == key);
      if (
        field &&
        field?.properties &&
        field.properties.filed_content &&
        ["READ ONLY", "DISABLED", "Hide"].includes(
          field.properties.filed_content
        )
      ) {
        return true;
      }
      return false;
    },
    getFieldOptions(template_id, key, entity) {
      return (
        entity.templates
          ?.find((e) => e?.templateInfo._id == template_id)
          .templateInfo.sections[0]?.fields?.find(
            (e) => e.key == key || e.key?.split("#")[1] == key
          ).options || []
      );
    },
    getDateViewType(step) {
      if (step?.date_view_type && step?.date_view_type != "day") {
        return step.date_view_type;
      }
      return null;
    },
    mapTableFieldsType(entity, columnFields) {
      if (entity?.templates) {
        let allFields = [];
        entity.templates.forEach((template) => {
          if (template?.templateInfo?.sections) {
            allFields = [
              ...allFields,
              ...this.applyCustomizationOnFields(
                this.getTemplateFields(template?.templateInfo),
                template.customization,
                template
              ),
            ];
          }
        });
        let result = [];
        columnFields.forEach((field) => {
          let mainId = field.id;
          if (mainId && mainId.includes("#")) {
            mainId = mainId.split("#")[1];
          }
          let found = allFields.find((el) => {
            let id = el.key;
            if (id && id.includes("#")) {
              id = id.split("#")[1];
            }
            if (mainId == id && field.template_id == el.template_id) {
              return true;
            }
          });
          if (found?.inputType) {
            field.type = found.inputType;
            field.label = found.label ? found.label : field.label;
            result.push(field);
          }
          if (this.isSystemColumn(field)) {
            result.push(field);
          }
        });
        return result;
      }
      return columnFields;
    },
    async updateUserEntityFieldsRelations(users) {
      let mappedUserDetails = {};
      users
        .filter((user) => user.contact_type)
        .forEach((user) => {
          mappedUserDetails[user.value] = {
            entity_id: user.contact_type._id || user.contact_type,
            data_id: user.entity_data_id
              ? user.entity_data_id._id
                ? user.entity_data_id._id
                : user.entity_data_id
              : "",
          };
        });
      this.elements.forEach((ele) => {
        if (ele.field_type == "ENTITY" && ele.filters && ele.filters.length) {
          let hasUserLikendFilter = ele.filters.filter(
            (e) => e.data_source == "user_entity" && e.data_type == "RELATION"
          );
          if (hasUserLikendFilter && hasUserLikendFilter.length) {
            let filters = ele.filters.map((e) => {
              if (
                e.data_source == "user_entity" &&
                e.data_type == "RELATION" &&
                mappedUserDetails[e.field.split("/")[1]]
              ) {
                let selectedUser = mappedUserDetails[e.field.split("/")[1]];
                if (selectedUser.data_id) {
                  e.relation_entity_id = selectedUser.entity_id;
                  e.value = selectedUser.data_id;
                }
              }
              return e;
            });
            ele.filters = [...filters];
            bus.$emit("entity-ur-updated", {
              field: ele,
            });
          }
        }
      });
    },
    async getEntityPrimaryTitle() {
      let name = "";
      let template =
        this.getEntityDataById &&
        this.getEntityDataById.primaryFields &&
        this.getEntityDataById.primaryFields[0]
          ? this.getEntityDataById.primaryFields[0]
          : null;
      let key =
        this.getEntityDataById &&
        this.getEntityDataById.primaryFields &&
        this.getEntityDataById.primaryFields[0] &&
        this.getEntityDataById.primaryFields[0].key
          ? this.getEntityDataById.primaryFields[0].key
          : this.entityPrimaryData &&
            this.entityPrimaryData.entity_prime_data &&
            Object.keys(this.entityPrimaryData.entity_prime_data) &&
            Object.keys(this.entityPrimaryData.entity_prime_data)[0]
          ? Object.keys(this.entityPrimaryData.entity_prime_data)[0]
          : null;
      if (
        this.entityPrimaryData &&
        this.entityPrimaryData.entity_prime_data &&
        template
      ) {
        if (key && this.entityPrimaryData.entity_prime_data[key]) {
          if (this.entityPrimaryData.entity_prime_data[key + "/name"]) {
            name = this.entityPrimaryData.entity_prime_data[key + "/name"];
          } else {
            name = this.entityPrimaryData.entity_prime_data[key];
          }
        } else {
          let data = await this.fetchPrimaryTemplateData(
            template.template_id,
            this.entityPrimaryData._id
          );
          if (key && data && data.template_data) {
            name = data.template_data[key];
          }
        }
      } else if (template) {
        let data = await this.fetchPrimaryTemplateData(
          template.template_id,
          this.entityPrimaryData._id
        );
        if (key && data && data.template_data) {
          name = data.template_data[key];
        }
      }
      this.getPrimaryTitle = name;
    },
    async getEntityPrimaryTitleFromNew() {
      let name = "";
      let template =
        this.getEntityDataById &&
        this.getEntityDataById.primaryFields &&
        this.getEntityDataById.primaryFields[0]
          ? this.getEntityDataById.primaryFields[0]
          : null;
      let key =
        this.getEntityDataById &&
        this.getEntityDataById.primaryFields &&
        this.getEntityDataById.primaryFields[0] &&
        this.getEntityDataById.primaryFields[0].key
          ? this.getEntityDataById.primaryFields[0].key
          : this.getNewEntityData &&
            this.getNewEntityData.entity_prime_data &&
            Object.keys(this.getNewEntityData.entity_prime_data) &&
            Object.keys(this.getNewEntityData.entity_prime_data)[0]
          ? Object.keys(this.getNewEntityData.entity_prime_data)[0]
          : null;
      if (this.getNewEntityData && this.getNewEntityData.entity_prime_data) {
        if (key && this.getNewEntityData.entity_prime_data[key]) {
          if (this.getNewEntityData.entity_prime_data[key + "/name"]) {
            name = this.getNewEntityData.entity_prime_data[key + "/name"];
          } else {
            name = this.getNewEntityData.entity_prime_data[key];
          }
        } else {
          let data = await this.fetchPrimaryTemplateData(
            template.template_id,
            this.getNewEntityData._id
          );
          if (key && data && data.template_data) {
            name = data.template_data[key];
          }
        }
      } else {
        let data = await this.fetchPrimaryTemplateData(
          template.template_id,
          this.entityPrimaryData._id
        );
        if (key && data && data.template_data) {
          name = data.template_data[key];
        }
      }
      this.getPrimaryTitle = name;
    },
    async fetchPrimaryTemplateData(templateId, entityDataId) {
      if (!templateId || !entityDataId) {
        return null;
      }
      await this.$store.dispatch("templatesData/fetchUserTemplateData", {
        entity_data_id: entityDataId,
        template_id: templateId,
      });
      if (this.getTemplatesData && this.getTemplatesData[0]) {
        return this.getTemplatesData[0];
      } else {
        return null;
      }
    },
    async fetchEntityData(id) {
      try {
        await this.$store.dispatch("entities/fetchEntityPrimaryDataById", id);
        if (this.getEntityPrimaryData) {
          this.entityPrimaryData = this.getEntityPrimaryData;
        }
      } catch (err) {
        console.log(err);
      }
    },
    getTemplateFields(data) {
      let fields = [];
      data.sections.forEach((e) => {
        fields = [...fields, ...e.fields];
      });
      fields = fields.map((e) => {
        e.template_id = data._id;
        return e;
      });
      return fields;
    },
    checkIsUserConfigured(item, documentUsers) {
      if (item) {
        if (item.field_type == "ENTITY_FIELD" && item.selected_user) {
          let selectedUser = documentUsers.find(
            (e) => e.value == item.selected_user
          );
          if (selectedUser && selectedUser.entity_data_id) {
            return false;
          } else {
            return true;
          }
        } else if (item.field_type == "ENTITY_VARIABLE") {
          return true;
        }
      }
      return false;
    },
    handleCloseRepeatable() {
      this.repeatableDataModal = false;
      this.newRepeatableData = {};
    },
    async addNewRepeatableData(documentUsers) {
      this.repeatableDataLoading = true;
      this.newRepeatableData = {
        ...this.newRepeatableData,
        ...{ indexKey: this.repeatableIds[0] },
      };
      let entityDataId = "";
      if (this.repeatableSelectedField.field_type == "ENTITY_FIELD") {
        const selectedUser = documentUsers.find(
          (e) => e.value == this.repeatableSelectedField.selected_user
        );
        if (selectedUser && selectedUser.entity_data_id) {
          entityDataId = selectedUser.entity_data_id._id
            ? selectedUser.entity_data_id._id
            : selectedUser.entity_data_id;
        }
      }
      await this.$store.dispatch("templatesData/addNewRepeatableData", {
        entity_data_id: entityDataId,
        template_id: this.repeatableSelectedField.template_id,
        template_data: this.newRepeatableData,
        company_id:
          this.getSingleDocumentData &&
          this.getSingleDocumentData.data &&
          this.getSingleDocumentData.data.company_id
            ? this.getSingleDocumentData.data.company_id
            : null,
        user_id:
          this.getSingleDocumentData &&
          this.getSingleDocumentData.data &&
          this.getSingleDocumentData.data.created_by
            ? this.getSingleDocumentData.data.created_by._id
              ? this.getSingleDocumentData.data.created_by._id
              : this.getSingleDocumentData.data.created_by
            : null,
      });
      if (this.getAddNewRepeatableDataStatus) {
        this.$notify.success({
          title: "Success",
          message: "Date saved successfully",
        });
        if (
          this.getAddNewRepeatableData &&
          this.getAddNewRepeatableData.template_data
        ) {
          if (this.repeatableSelectedField.field_type == "ENTITY_FIELD") {
            const selectedUser = documentUsers.find(
              (e) => e.value == this.repeatableSelectedField.selected_user
            );
            let templateData = this.getTemplatesData;
            const selectedTemplateDataIndex =
              this.getTemplatesData && this.getTemplatesData.length
                ? this.getTemplatesData.findIndex(
                    (t) =>
                      (selectedUser &&
                        selectedUser.entity_data_id &&
                        t.template_id ==
                          this.repeatableSelectedField.template_id &&
                        t.entity_data_id == selectedUser.entity_data_id._id) ||
                      t.entity_data_id == selectedUser.entity_data_id
                  )
                : null;
            if (selectedTemplateDataIndex > -1) {
              templateData[selectedTemplateDataIndex] = {
                ...this.getAddNewRepeatableData,
              };
            }
            await this.$store.commit(
              "templatesData/setTemplatesData",
              templateData,
              {
                root: true,
              }
            );
            let allParentFields = this.elements.filter(
              (e) =>
                e.selected_user == this.repeatableSelectedField.selected_user &&
                e.type == "REPEATABLE_PARENT" &&
                e.template_id == this.repeatableSelectedField.template_id &&
                e.entity_id == this.repeatableSelectedField.entity_id
            );
            if (allParentFields && allParentFields.length) {
              allParentFields.forEach((el) => {
                let parentIndex = this.elements.findIndex(
                  (e) => e.key == el.key
                );
                if (
                  parentIndex > -1 &&
                  Object.keys(this.getAddNewRepeatableData.template_data)[0]
                ) {
                  let data =
                    this.getAddNewRepeatableData.template_data[
                      Object.keys(this.getAddNewRepeatableData.template_data)[0]
                    ];
                  let obj = this.elements[parentIndex];
                  obj.repeatable_data = data;
                  if (el.key == this.repeatableSelectedField.key) {
                    obj.indexKey = this.newRepeatableData.indexKey;
                  }
                  this.elements[parentIndex] = { ...obj };
                  bus.$emit("repeatable-data-selected", {
                    key: el.key,
                    repeatableData: data,
                    indexKey:
                      el.key == this.repeatableSelectedField.key
                        ? this.newRepeatableData.indexKey
                        : null,
                  });
                }
              });
            }
          }
          console.log(
            "this.elements this.elements this.elements",
            this.elements
          );
        }
        this.handleCloseRepeatable();
        this.repeatableDataLoading = false;
      } else {
        this.repeatableDataLoading = false;
        let message = "Error while adding data";
        if (
          this.getAddNewRepeatableDataErrors &&
          this.getAddNewRepeatableDataErrors.message
        ) {
          message = this.getAddNewRepeatableDataErrors.message;
        }
        this.$notify.error({
          title: "Error",
          message: message,
        });
      }
      console.log("newRepeatableData", this.newRepeatableData);
      console.log("indexKeys", this.repeatableIds, entityDataId);
    },
    setRepeatableUserDataToField(selectedUser, template_id) {
      console.log(
        "-=-=-=-=-======-=-",
        this.allTemplatesData[selectedUser + "-" + template_id]
      );
      let dataValues = this.allTemplatesData[selectedUser + "-" + template_id];
      if (dataValues && Object.keys(dataValues)[0]) {
        return dataValues[Object.keys(dataValues)[0]];
      } else {
        return null;
      }
    },
    setRepeatableDataStucture(data, name) {
      if (data && Object.keys(data) && Object.keys(data).length > 1) {
        let obj = data;
        data = {};
        if (obj && obj.indexKey) {
          data[name] = [obj];
        } else {
          data[name] = [{ ...obj, ...{ indexKey: "newData:0" } }];
        }
      }
      return data;
    },
    async updateEntityVariablesData(entityDataId, field, data, value, changed) {
      let originalFields = this.elements;
      let parentIndex = originalFields.findIndex((e) => e.key == field.key);
      if (
        parentIndex != -1 &&
        originalFields[parentIndex] &&
        originalFields[parentIndex].key == field.key
      ) {
        let repeatableEvents = [];
        let entityFieldEvenets = [];
        let temp = {
          entity_data_id: entityDataId,
          value: value ? value : entityDataId,
        };
        // field.entity_data_id = entityDataId;
        // field.value = value ? value : entityDataId;
        this.elements[parentIndex] = { ...this.elements[parentIndex], ...temp };
        let fields = this.elements;
        if (field.type == "ENTITY") {
          await setTimeout(async () => {
            this.elements = [];
            await fields.forEach((e, i) => {
              if (
                e.parent_entity_field_key == field.key &&
                !e.parent_repeatable_field_key &&
                ((e && e.key && !e.key.includes("~")) ||
                  (e && e.key && e.key.includes("-"))) &&
                (changed ||
                  e.value == null ||
                  e.value == undefined ||
                  e.value == "")
              ) {
                let fieldTemplateId = e.template_id;
                let key = e.key;
                if (e.type != "REPEATABLE_PARENT") {
                  if (e.indexKey) {
                    key = key.split("-")[2];
                  } else if (key && key.includes("-")) {
                    if (
                      e.parent_entity_field_key &&
                      key.includes(e.parent_entity_field_key)
                    ) {
                      key = key.replace(e.parent_entity_field_key, "");
                    }
                    key = key.split("-")[1];
                  }
                  if (key && key.includes("#")) {
                    key = key.split("#")[0];
                  }
                }
                if (
                  e.field_type == "ENTITY_FIELD" &&
                  e.parent_template_field &&
                  e.parent_template_field.includes("#")
                ) {
                  fieldTemplateId = e.parent_template_field.split("#")[0];
                  key = e.parent_template_field.split("#")[1];
                }
                if (data[fieldTemplateId]) {
                  if (
                    e.indexKey ||
                    (e.type == "REPEATABLE_PARENT" &&
                      !e.parent_repeatable_field_key)
                  ) {
                    let selectedData = data[fieldTemplateId];
                    if (selectedData) {
                      let repeatableData =
                        selectedData[Object.keys(selectedData)[0]];
                      if (e.type == "REPEATABLE_PARENT") {
                        this.$set(e, "repeatable_data", repeatableData);
                        // bus.$emit("repeatable-data-selected", {
                        //   key: e.key,
                        //   repeatableData: repeatableData,
                        // });
                        repeatableEvents.push({
                          key: e.key,
                          repeatableData: repeatableData,
                        });
                      } else {
                        if (e.indexKey.includes(":")) {
                          let index = e.indexKey.split(":")[1];
                          this.$set(
                            e,
                            "value",
                            repeatableData[index - 1] &&
                              repeatableData[index - 1][key]
                              ? repeatableData[index - 1][key + "/name"]
                                ? repeatableData[index - 1][key + "/name"]
                                : repeatableData[index - 1][key]
                              : ""
                          );
                          if (e.is_use_boxes) {
                            this.$set(
                              e,
                              "boxes",
                              repeatableData[index - 1] &&
                                repeatableData[index - 1][key]
                                ? repeatableData[index - 1][key + "/name"]
                                  ? Array.from(
                                      repeatableData[index - 1][key + "/name"]
                                    )
                                  : Array.from(repeatableData[index - 1][key])
                                : ""
                            );
                          }

                          if (e.type == "ENTITY") {
                            e.entity_data_id = e.value;
                            // bus.$emit("entityDataId-selected", {
                            //   entityDataId:
                            //     repeatableData[index - 1] &&
                            //     repeatableData[index - 1][key]
                            //       ? repeatableData[index - 1][key]
                            //       : "",
                            //   form: e,
                            //   reset: true,
                            // });
                            entityFieldEvenets.push({
                              entityDataId:
                                repeatableData[index - 1] &&
                                repeatableData[index - 1][key]
                                  ? repeatableData[index - 1][key]
                                  : "",
                              form: e,
                              reset: true,
                            });
                          }
                        } else {
                          let selectedRow = repeatableData.find(
                            (el) => el.indexKey == e.indexKey
                          );
                          if (e.is_use_boxes) {
                            this.$set(
                              e,
                              "boxes",
                              selectedRow && selectedRow[key]
                                ? Array.from(selectedRow[key])
                                : ""
                            );
                          }
                          this.$set(
                            e,
                            "value",
                            selectedRow && selectedRow[key]
                              ? selectedRow[key]
                              : ""
                          );
                        }
                      }
                    } else {
                      if (e.is_use_boxes) {
                        this.$set(e, "boxes", "");
                      }
                      this.$set(e, "value", "");
                      if (e.type == "REPEATABLE_PARENT") {
                        this.$set(e, "repeatable_data", []);
                        // bus.$emit("repeatable-data-selected", {
                        //   key: e.key,
                        //   repeatableData: [],
                        // });
                        repeatableEvents.push({
                          key: e.key,
                          repeatableData: [],
                        });
                      }
                    }
                  } else {
                    if (e.type == "ENTITY") {
                      if (e.is_use_boxes) {
                        this.$set(
                          e,
                          "boxes",
                          data[fieldTemplateId][key + "/name"]
                            ? Array.from(data[fieldTemplateId][key + "/name"])
                            : Array.from(data[fieldTemplateId][key])
                            ? Array.from(data[fieldTemplateId][key])
                            : ""
                        );
                      }
                      this.$set(
                        e,
                        "value",
                        data[fieldTemplateId][key + "/name"]
                          ? data[fieldTemplateId][key + "/name"]
                          : data[fieldTemplateId][key]
                          ? data[fieldTemplateId][key]
                          : ""
                      );
                      this.$set(
                        e,
                        "entity_data_id",
                        data[fieldTemplateId][key]
                          ? data[fieldTemplateId][key]
                          : ""
                      );
                      // bus.$emit("entityDataId-selected", {
                      //   entityDataId: data[fieldTemplateId][key]
                      //     ? data[fieldTemplateId][key]
                      //     : "",
                      //   form: e,
                      //   reset: true,
                      // });
                      entityFieldEvenets.push({
                        entityDataId: data[fieldTemplateId][key]
                          ? data[fieldTemplateId][key]
                          : "",
                        form: e,
                        reset: true,
                      });
                    } else {
                      if (e.is_use_boxes) {
                        let formattedDate = "";
                        if (e && e.type == "DATE") {
                          const date = new Date(data[fieldTemplateId][key]);
                          const month = String(date.getMonth() + 1).padStart(
                            2,
                            "0"
                          );
                          const day = String(date.getDate()).padStart(2, "0");
                          const year = String(date.getFullYear());
                          formattedDate = `${month}${day}${year}`;
                          this.$set(
                            e,
                            "boxes",
                            formattedDate ? Array.from(formattedDate) : ""
                          );
                        } else {
                          this.$set(
                            e,
                            "boxes",
                            data[fieldTemplateId][key]
                              ? Array.from(data[fieldTemplateId][key])
                              : ""
                          );
                        }
                      }
                      if (e.is_checkbox_group) {
                        let index = e.key.split("/")[1];
                        if (data[fieldTemplateId][key].includes(index)) {
                          this.$set(e, "value", true);
                        } else {
                          this.$set(e, "value", "");
                        }
                      } else {
                        this.$set(
                          e,
                          "value",
                          data[fieldTemplateId][key]
                            ? data[fieldTemplateId][key]
                            : ""
                        );
                      }
                    }
                  }
                } else {
                  if (e.is_use_boxes) {
                    this.$set(e, "boxes", "");
                  }
                  this.$set(e, "value", "");
                  if (e.type == "REPEATABLE_PARENT") {
                    this.$set(e, "repeatable_data", []);
                    // bus.$emit("repeatable-data-selected", {
                    //   key: e.key,
                    //   repeatableData: [],
                    // });
                    repeatableEvents.push({
                      key: e.key,
                      repeatableData: [],
                    });
                  } else if (e.type == "ENTITY") {
                    entityFieldEvenets.push({
                      entityDataId: "",
                      form: e,
                      reset: true,
                    });
                  }
                }
                fields[i] = { ...e };
              }
              this.elements.push(e);
              if (i + 1 == fields.length) {
                if (entityFieldEvenets.length) {
                  entityFieldEvenets.forEach(async (ev) => {
                    await bus.$emit("entityDataId-selected", {
                      entityDataId: ev.entityDataId,
                      form: ev.form,
                      reset: ev.reset,
                      isEntityVariable: true,
                    });
                  });
                }
                if (repeatableEvents.length) {
                  repeatableEvents.forEach(async (ev) => {
                    await bus.$emit("repeatable-data-selected", {
                      key: ev.key,
                      repeatableData: ev.repeatableData,
                    });
                  });
                }
              }
            });
          }, 100);
        }
      }
    },
    getTemplateFieldKey(key, el) {
      if (el.type != "REPEATABLE_PARENT") {
        if (el.indexKey) {
          key = key.split("-")[2];
        } else {
          key = key.split("-")[1];
        }
        if (key.includes("#")) {
          key = key.split("#")[0];
        }
      }
      return key;
    },
    getTemplateFieldValue(el) {
      if (el.type == "ENTITY") {
        return {
          value: el.value,
          entity_data_id: el.entity_data_id,
        };
      } else if (el.indexKey) {
        if (el.type == "ENTITY") {
          return {
            value: el.value,
            entity_data_id: el.entity_data_id,
            indexKey: el.indexKey,
          };
        }
        return {
          indexKey: el.indexKey,
          value: el.value,
        };
      }
      return el.value;
    },
    setTemplateFieldValue(data, key, indexKey) {
      console.log(data, key, indexKey);
      if (indexKey) {
        let innerRow = data && data["data"] ? data["data"] : [];
        if (innerRow && innerRow.length) {
          let selectedRow = innerRow.find((e) => e && e.indexKey == indexKey);
          if (selectedRow && selectedRow[key]) {
            return selectedRow[key];
          }
          // else if(indexKey.includes(":") && indexKey.split(":") && innerRow[indexKey.split(":")[1] - 1]){
          //   return innerRow[indexKey.split(":")[1] - 1][key] ? innerRow[indexKey.split(":")[1] - 1][key] : '';
          // }
          return "";
        }
        return "";
      }
      return data[key] ? data[key] : "";
    },
    updateRepeatableVariablesData(repeatableDataId, field, data, value) {
      let originalFields = this.elements;
      let parentIndex = originalFields.findIndex((e) => e.key == field.key);
      if (
        parentIndex != -1 &&
        originalFields[parentIndex] &&
        originalFields[parentIndex].key == field.key
      ) {
        field.indexKey = repeatableDataId;
        field.value = repeatableDataId
          ? value
            ? value
            : repeatableDataId
          : "";
        this.elements[parentIndex] = {
          ...this.elements[parentIndex],
          ...field,
        };
        let fields = this.elements;
        setTimeout(() => {
          this.elements = [];
          fields.map((e, i) => {
            if (e.parent_repeatable_field_key == field.key) {
              let key = e.key;
              if (e.indexKey) {
                key = key.split("-")[2];
              } else {
                key = key.split("-")[1];
              }
              if (key.includes("#")) {
                key = key.split("#")[0];
              }
              e.indexKey = repeatableDataId ? repeatableDataId : "newData:1";
              e.key =
                field.key +
                "-" +
                (repeatableDataId ? repeatableDataId : "newData:1") +
                "-" +
                key +
                "#" +
                field.template_id;
              if (data[key]) {
                this.$set(
                  e,
                  "value",
                  data[key + "/name"] ? data[key + "/name"] : data[key]
                );
                e.indexKey = field.indexKey;
                e.key =
                  field.key +
                  "-" +
                  field.indexKey +
                  "-" +
                  key +
                  "#" +
                  field.template_id;
                if (e.type == "ENTITY") {
                  this.$set(e, "entity_data_id", data[key]);
                  bus.$emit("entityDataId-selected", {
                    entityDataId: data[key] ? data[key] : e.value,
                    form: e,
                    reset: true,
                  });
                }
              } else {
                if (e.type == "ENTITY") {
                  this.$set(e, "entity_data_id", e.value);
                  bus.$emit("entityDataId-selected", {
                    entityDataId: e.value,
                    form: e,
                    reset: true,
                  });
                }
                this.$set(e, "value", "");
              }
              fields[i] = { ...e };
            }
            this.elements.push(e);
          });
        }, 100);
      }
    },
    getAllFieldsFromEntityData(entityData) {
      return entityData.sections
        .map((section) => section.fields)
        .reduce((sectionAFields, sectionBFields) => {
          return sectionAFields.concat(sectionBFields);
        });
    },
    getRelationshipFields(entityData) {
      let allFields = this.getAllFieldsFromEntityData(entityData);
      return allFields.filter((field) => field.input_type == "GLOBAL_VARIABLE");
    },
    async setEntityData(documentUsers) {
      this.allTemplatesData = {};
      let params = {
        entity_data_ids: [],
      };
      documentUsers.forEach((e) => {
        if (e.entity_data_id) {
          if (e.entity_data_id._id) {
            params.entity_data_ids.push(e.entity_data_id._id);
          } else {
            params.entity_data_ids.push(e.entity_data_id);
          }
        }
      });
      await this.$store.commit("templatesData/setTemplatesData", [], {
        root: true,
      });
      if (params.entity_data_ids && params.entity_data_ids.length) {
        await this.$store.dispatch(
          "templatesData/fetchUserTemplateData",
          params
        );
        this.setUsersEntityData(documentUsers);
      }
    },
    setUsersEntityData(documentUsers) {
      if (this.getTemplatesData && this.getTemplatesData.length) {
        documentUsers.forEach((e) => {
          const seletedUserTemplateData = this.getTemplatesData.filter(
            (dt) =>
              (e.entity_data_id &&
                e.entity_data_id._id &&
                dt.entity_data_id == e.entity_data_id._id) ||
              dt.entity_data_id == e.entity_data_id
          );
          seletedUserTemplateData.forEach((dt) => {
            this.allTemplatesData[e.value + "-" + dt.template_id] =
              dt.template_data;
          });
          this.elements.map((el) => {
            if (
              el.template_id &&
              el.selected_user == e.value &&
              this.allTemplatesData &&
              this.nonCompletedUserValues.indexOf(el.filled_by) != -1
            ) {
              if (el.type == "REPEATABLE_PARENT") {
                let value = this.setRepeatableUserDataToField(
                  el.selected_user,
                  el.template_id
                );
                console.log(" new value", value);
                if (value) {
                  el.repeatable_data = value;
                } else {
                  el.repeatable_data = [];
                }
                bus.$emit("repeatable-data-selected", {
                  key: el.key,
                  repeatableData: value,
                });
              } else {
                let value;
                if (
                  el.type == "CHECKBOX" &&
                  el.group_key &&
                  el.is_checkbox_group
                ) {
                  value = this.setCheckboxesDataToEntityField(
                    el.key,
                    el.template_id,
                    el.indexKey
                  );
                } else {
                  value = this.setEntityDataToField(
                    el.key,
                    el.template_id,
                    el.indexKey,
                    el.type,
                    el.allow_multiple
                  );
                }
                if (value) {
                  if (el.type == "ENTITY") {
                    this.$set(
                      el,
                      "entity_data_id",
                      value
                        ? typeof value == "string" &&
                          value.includes("-") &&
                          value.split("-")[0]
                          ? value.split("-")[0]
                          : value
                        : ""
                    );
                  }
                  el.value = value
                    ? typeof value == "string" &&
                      el.type == "ENTITY" &&
                      value.includes("-") &&
                      value.split("-")[1]
                      ? value.split("-")[1]
                      : value
                    : "";
                }
              }
            }
          });
        });
      }
    },
    setCheckboxesDataToEntityField(checkKey, tempId, indexKey) {
      console.log("----------==============", checkKey, indexKey);
      let dataCheck =
        this.allTemplatesData[checkKey.split("-")[0] + "-" + tempId];
      let key = checkKey.split("-")[1];
      if (key.includes("#")) {
        key = key.split("#")[0];
      }
      let checkBoxKey = checkKey.split("/")[1];
      return dataCheck &&
        dataCheck[key] &&
        dataCheck[key].indexOf(checkBoxKey) !== -1
        ? true
        : false;
    },
    setEntityDataToField(
      rawKey,
      template_id,
      indexKey,
      type,
      allow_multiple = false
    ) {
      let dataValues =
        this.allTemplatesData[rawKey.split("-")[0] + "-" + template_id];
      if (dataValues) {
        if (indexKey && Object.keys(dataValues)[0]) {
          let key = rawKey.split("-")[2];
          if (key.includes("#")) {
            key = key.split("#")[0];
          }
          let innerData = dataValues[Object.keys(dataValues)[0]];
          if (innerData && innerData.length) {
            let selectedInnerData = innerData.find(
              (e) => e && e.indexKey == indexKey
            );
            if (selectedInnerData && selectedInnerData[key]) {
              return (
                selectedInnerData[key] +
                "" +
                (selectedInnerData[key + "/name"]
                  ? "-" + selectedInnerData[key + "/name"]
                  : "")
              );
            }
          }
        } else {
          let key = rawKey.split("-")[1];
          if (key.includes("#")) {
            key = key.split("#")[0];
          }
          if (
            ((allow_multiple && type == "WEEKDAYS") ||
              type === "TIME_RANGE" ||
              type === "DATE_RANGE" ||
              type === "DATE_TIME_RANGE" ||
              type === "MULTI_SELECT") &&
            dataValues[key] !== undefined &&
            typeof dataValues[key] === "object"
          ) {
            return dataValues[key] ? dataValues[key] : [];
          }
          if (
            dataValues[key] === undefined ||
            dataValues[key] === null ||
            dataValues[key] === "undefined" ||
            dataValues[key] === "null"
          ) {
            dataValues[key] = "";
            return (
              dataValues[key] +
              "" +
              (dataValues[key + "/name"] ? "-" + dataValues[key + "/name"] : "")
            );
          }
          if (dataValues[key]) {
            return (
              dataValues[key] +
              "" +
              (dataValues[key + "/name"] ? "-" + dataValues[key + "/name"] : "")
            );
          } else {
            return "";
          }
        }
      }
      return "";
    },
    async companyEntityDetails() {
      try {
        await this.$store.dispatch("entities/fetchCompanyEntityDetails");
        if (
          this.getCompanyEntityDetails &&
          this.getCompanyEntityDetails.entity_data_details &&
          this.getCompanyEntityDetails.entity_data_details[0] &&
          this.documentUsers.length
        ) {
          this.documentUsers.forEach((e) => {
            if (e.type == "SENDER") {
              this.$set(
                e,
                "entity_data_id",
                this.getCompanyEntityDetails.entity_data_details[0]._id
              );
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async checkForEntityDataUpdate(documentUsers) {
      if (documentUsers && documentUsers.length) {
        this.nonCompletedUserValues = documentUsers
          .filter(
            (user) => user.user_type != "CC" && !user.document_filling_status
          )
          .flatMap((e) => e.value);
        if (this.nonCompletedUserValues && this.nonCompletedUserValues.length) {
          let params = {
            entity_data_ids: [],
          };
          documentUsers.forEach((e) => {
            if (e.entity_data_id) {
              if (e.entity_data_id._id) {
                params.entity_data_ids.push(e.entity_data_id._id);
              } else {
                params.entity_data_ids.push(e.entity_data_id);
              }
            }
            if (e && e.contact_type && e.contact_type.templates) {
              let repeatableKeys = e.contact_type.templates
                .filter((temp) => temp && temp.is_repeatable)
                .flatMap((temp) => temp.template_id);
              if (repeatableKeys && repeatableKeys.length) {
                this.allUsersRepeatableDataKeys[e.value] = repeatableKeys;
              }
            }
          });
          await this.$store.commit("templatesData/setTemplatesData", [], {
            root: true,
          });
          if (params.entity_data_ids && params.entity_data_ids.length) {
            await this.$store.dispatch(
              "templatesData/fetchUserTemplateData",
              params
            );
          }
        }
      }
    },
    prepareUserEntityDataForCk(users, elements, filesData) {
      let allData = {};
      users =
        users ||
        (this.getSingleDocumentData &&
          this.getSingleDocumentData.data &&
          this.getSingleDocumentData.data.document_users);
      console.log(users);
      users.forEach((user) => {
        if (user && user.entity_data_id) {
          let userId = user.entity_data_id._id || user.entity_data_id;
          let templates = allData[userId] || {};
          let currentUserFields = elements.filter(
            (e) =>
              (e.selected_user
                ? e.selected_user === user.value
                : e.filled_by === user.value) &&
              !e.isStatic &&
              !e.input_type.startsWith("PRIMARY_FIELDS")
          );
          let groupObj = {};
          currentUserFields.forEach((e) => {
            let obj = {};
            let key = e.key.split("@")[1];
            if (e.template_id && e.template_id !== "") {
              if (e.type === "ENTITY") {
                obj[key] = e.entity_data_id;
                obj[key + "/name"] = e.value;
              } else if (e.type === "FILE") {
                obj[key] = filesData[e.key];
              } else if (e.type === "IMAGE" || e.type === "GIF") {
                obj[key] = e.image_url ? e.image_url : e.value;
              } else if (
                (e.type === "CHECKBOX" && e.group_key && e.value === true) ||
                (e.value === "true" && e.is_checkbox_group)
              ) {
                let value = e.key.split("/")[1];
                if (groupObj[key]) {
                  groupObj[key].push(value);
                } else {
                  groupObj[key] = [value];
                }
                obj[key] = [...groupObj[key]];
              } else if (
                e.type === "CHECKBOX" &&
                e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              } else if (
                e.type !== "CHECKBOX" &&
                !e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              }
              templates[e.template_id] = {
                ...templates[e.template_id],
                ...obj,
              };
            }
          });
          allData[userId] = templates;
        }
      });
      console.log("allData:", allData);
      return allData;
    },
    async updateCurrentUserEntityDataForCkEditorFields(
      doUsers,
      ckEditorFields,
      isAfterFinish
    ) {
      try {
        let editorFields =
          isAfterFinish === true
            ? ckEditorFields
            : this.getSingleDocumentData &&
              this.getSingleDocumentData.data &&
              this.getSingleDocumentData.data.configurable_document_data &&
              this.getSingleDocumentData.data.configurable_document_data
                .ckeditor_fields;
        let allData = this.prepareUserEntityDataForCk(
          doUsers,
          editorFields,
          this.filesData
        );
        await this.$store.dispatch(
          "templatesData/updateUserEntityData",
          allData
        );
      } catch (error) {
        console.log(error);
        this.$notify.error({
          title: "Error",
          message: error,
        });
      }
    },
    async updateCurrentUserEntityData(users) {
      try {
        let allData = this.prepareUserEntityData(
          users,
          this.elements,
          this.filesData
        );
        await this.$store.dispatch(
          "templatesData/updateUserEntityData",
          allData
        );
      } catch (error) {
        console.log(error);
        this.$notify.error({
          title: "Error",
          message: error,
        });
      }
    },
    prepareUserEntityData(users, elements, filesData) {
      let allData = {};

      users.forEach((user) => {
        if (user && user.entity_data_id) {
          let currentUserFields = elements.filter(
            (e) =>
              e.selected_user == user.value &&
              e.field_type == "ENTITY_FIELD" &&
              e.type != "REPEATABLE_PARENT"
          );
          let userId = user.entity_data_id._id || user.entity_data_id;
          let templates = allData[userId] || {};
          let groupObj = {};
          currentUserFields.forEach((e) => {
            if (!e.indexKey) {
              if (e.group_key) {
                e.group_key = e.group_key.trim();
              }
              let obj = {};
              console.log("e.key", e.key);
              let key = e.key.split("-")[1];
              console.log("e.key1", key);
              if (key && key.includes("#")) {
                key = key.split("#")[0];
                console.log("e.key12", key);
              }
              if (e.type == "ENTITY") {
                obj[key] = e.entity_data_id;
                obj[key + "/name"] = e.value;
              } else if (e.type == "FILE") {
                obj[key] = filesData[e.key];
              } else if (e.type == "IMAGE" || e.type == "GIF") {
                obj[key] = e.image_url ? e.image_url : e.value;
              } else if (
                (e.type == "CHECKBOX" && e.group_key && e.value == true) ||
                (e.value == "true" && e.is_checkbox_group)
              ) {
                let value = e.key.split("/")[1];
                if (groupObj[key]) {
                  groupObj[key].push(value);
                } else {
                  groupObj[key] = [value];
                }
                obj[key] = [...groupObj[key]];
              } else if (
                e.type == "CHECKBOX" &&
                e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              } else if (
                e.type != "CHECKBOX" &&
                !e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              }
              templates[e.template_id] = {
                ...templates[e.template_id],
                ...obj,
              };
            } else {
              let obj = {
                indexKey: e.indexKey,
              };
              let key = e.key.split("-")[2];
              if (key && key.includes("#")) {
                key = key.split("#")[0];
              }
              if (e.type == "ENTITY") {
                obj[key] = e.entity_data_id;
                obj[key + "/name"] = e.value;
              } else if (
                (e.type == "CHECKBOX" && e.group_key && e.value == true) ||
                (e.value == "true" && e.is_checkbox_group)
              ) {
                let value = e.key.split("/")[1];
                if (groupObj[key]) {
                  groupObj[key].push(value);
                } else {
                  groupObj[key] = [value];
                }
                obj[key] = [...groupObj[key]];
              } else if (
                e.type == "CHECKBOX" &&
                e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              } else if (
                e.type != "CHECKBOX" &&
                !e.group_key &&
                !e.is_checkbox_group
              ) {
                obj[key] = e.value;
              }
              if (
                templates[e.template_id] &&
                templates[e.template_id]["data"] &&
                templates[e.template_id]["data"].length
              ) {
                let existedDataIndex = templates[e.template_id][
                  "data"
                ].findIndex((el) => el && el.indexKey == obj.indexKey);
                if (existedDataIndex == -1) {
                  templates[e.template_id]["data"].push(obj);
                } else {
                  templates[e.template_id]["data"][existedDataIndex] = {
                    ...templates[e.template_id]["data"][existedDataIndex],
                    ...obj,
                  };
                }
              } else {
                templates[e.template_id] = {
                  data: [obj],
                  isRepeatable: true,
                };
              }
            }
          });
          allData[userId] = templates;
        }
      });
      console.log('console.log("e.key1", key);', allData);
      return allData;
    },
    async fetchEntityDetails(
      id,
      includeLabel = false,
      includeSlugKey = false,
      include_data_tables = false,
      ogLabel = false,
      isFromCk = true,
      include_customization = false,
      populatedEntity = null
    ) {
      // await this.$store.dispatch("entities/fetchChildEntityById", id);
      let getChildEntityDataById;
      if (populatedEntity) {
        getChildEntityDataById = populatedEntity;
      } else {
        getChildEntityDataById = await fetchEntityById(id, isFromCk);
      }

      let allFields = [];
      if (getChildEntityDataById && getChildEntityDataById.templates) {
        getChildEntityDataById.templates.forEach((template) => {
          if (
            template?.templateInfo?.sections[0]?.fields ||
            template?.template_id?.sections[0]?.fields
          ) {
            let tempFields = [];
            if (include_customization) {
              tempFields = this.applyCustomizationOnFields(
                this.getTemplateFieldsInfo(
                  template?.templateInfo || template?.template_id,
                  includeLabel,
                  includeSlugKey,
                  include_data_tables,
                  ogLabel
                ),
                template.customization,
                template
              ).map((f) => {
                if (f?.key && !f.key.includes("#")) {
                  f.key = f.template_id + "#" + f.key;
                }
                if(!(f.template_key?.includes("#"))) {
                  f.template_key = f.key.includes("#") ? f.key : f.template_id + "#" + f.key;
                }
                return f;
              });
            } else {
              tempFields = this.getTemplateFieldsInfo(
                template?.templateInfo || template?.template_id,
                includeLabel,
                includeSlugKey,
                include_data_tables,
                ogLabel
              );
            }
            allFields = [...allFields, ...tempFields];
          }
        });
        return allFields;
      }
    },
    async fetchEntitiesDataForTable(
      currentEntity,
      page = 1,
      limit = 500,
      searchString = "",
      filters = [],
      dataIds = [],
      relationshipFilter = ""
    ) {
      let params = {
        entity_id: currentEntity._id,
        filters: filters,
        relationship: relationshipFilter,
        limit: limit,
        page: page,
        ignore_populate: true,
      }, entitiesData = [];
      if (searchString) {
        params.search_string = searchString;
        params.primary_search_fields = this.getSearchPrimaryFields(
          0,
          currentEntity
        );
      }
      if (dataIds.length) {
        params.entity_data_ids = dataIds;
      }
      let relatedToSelfFilter = params.filters?.findIndex(
        (e) => e.field == "self#related_to/self"
      );
      if (relatedToSelfFilter != -1) {
        if (this.data.parent_entityId == this.data.entity_id) {
          params.entity_data_ids = [this.data.parent_entityDataId];
        }
        params.filters.splice(relatedToSelfFilter, 1);
      }
      if (currentEntity.company_id) {
        params.company_id = currentEntity.company_id;
      }
      // if (this.data?.entity_sort) {
      //   let [order, by] = this.data.entity_sort.split("/");
      //   params.sortBy = by;
      //   params.sortOrder = order;
      // }
      if (
        currentEntity &&
        currentEntity.created_by &&
        currentEntity.company_id
      ) {
        params.user_id = currentEntity.created_by;
        params.company_id = currentEntity.company_id;
      }
      try {
        const response = await postAPICall(
          "POST",
          "/entities-data/entity/data",
          params
        );
        if (response) {
          entitiesData = [...entitiesData, ...response.data];
        }
        return entitiesData;
      } catch (e) {
        console.log("Error while fetching entities data");
        return [];
      }
    },
    async getEntityDataByIds(entity_id,dataIds) {
      let params = {
        entity_id: entity_id,
        filters: [],
        relationship: "",
        limit: 100,
        page: 1,
        ignore_populate: true,
        entity_data_ids : dataIds
      }
      try {
        const response = await postAPICall(
          "POST",
          "/entities-data/entity/data",
          params
        );
        if (response) {
          return response.data;
        }
        return [];
      } catch (e) {
        console.log("Error while fetching entities data");
        return [];
      }
    },
    getTemplateFieldsInfo(
      data,
      includeLabel,
      includeSlugKey = false,
      include_data_tables = false,
      ogLabel = false
    ) {
      let fields = [];
      data.sections.forEach((e) => {
        fields = [...fields, ...e.fields];
      });

      fields = fields.map((e) => {
        e.template_id = data._id;
        if(!(e.template_key?.includes('#'))) {
          e.template_key = data._id + "#" + e.key;
        }
        e.template_name = data.name;
        e.orgLabel = e.label;
        if (includeLabel) {
          e.label =
            e.label && e.label.includes(`${data.name} - `)
              ? e.label
              : data.name + " - " + e.label;
        } else if (!ogLabel) {
          e.label = data.slug + "#" + e.key;
        }
        if (includeSlugKey && !e.key.includes("_")) {
          e.key = data.slug + "_" + e.key;
        }
        return e;
      });
      if (include_data_tables) {
        //have to check data table fields
        let dataTableFields = fields.filter(
          (e) => e?.inputType == "DATA_TABLE"
        );
        if (dataTableFields && dataTableFields.length) {
          dataTableFields.forEach((fl) => {
            if (fl?.data_table_columns) {
              fields = [
                ...fields,
                ...fl?.data_table_columns.map((e) => {
                  e.data_table_key = fl.key;
                  e.template_id = data._id;
                  e.label = fl.label + "-" + e.label;
                  e.all_duplicate_rules = fl.all_duplicate_rules;
                  e.duplicate_query_type = fl.duplicate_query_type;
                  if (
                    fl.input_type == "ENTITY_VARIABLE" &&
                    fl?.relationship_key
                  ) {
                    e.table_relationship_key = fl.relationship_key;
                  }
                  e.orgLabel = e.label;

                  // if (includeLabel) {
                  //   e.label = data.name + " - " + e.label;
                  // } else {
                  //   e.label = data.slug + "#" + e.key;
                  // }
                  if (includeSlugKey) {
                    e.key = data.slug + "_" + e.key;
                  }
                  e.template_id = data._id;
                  if(!e.template_key?.includes('#')) {
                    e.template_key = data._id + "#" + e.key;
                  }
                  e.template_name = data.name;
                  e["isDataTableField"] = true;
                  // if (include_data_table_key) {
                  //   e.key = e.data_table_key + "/" + e.key;
                  // }
                  return e;
                }),
              ];
            }
          });
        }
        fields = fields.filter((e) => {
          return e.inputType != "DATA_TABLE";
        });
      }
      return fields;
    },
    async downloadEntityDataPdf(url, file_name) {
      axios.defaults.headers.common = {
        "Access-Control-Allow-Origin": window.location.origin,
      };
      axios.defaults.headers.common = {
        "Access-Control-Allow-Origin": window.location.origin,
      };
      await fetch(url, { method: "get", responseType: "blob" })
        .then((res) => res.blob())
        .then((blob) => {
          var fileURL = window.URL.createObjectURL(new Blob([blob]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", file_name + ".pdf");
          document.body.appendChild(fileLink);

          fileLink.click();
        });
    },
    async downloadFile(data) {
      this.loading = true;
      this.loadingText = "Downloading File....";
      let fileName = data.name;
      fileName = await fileName.replace(/\//g, "-");
      fileName = await fileName.replace(/ /g, "_");
      fileName = await fileName.replace(/[()]/g, "");
      if (data && !data.path) {
        data.path = `template-data-documents/${fileName}`;
      }
      await this.$store.dispatch("templatesData/downloadTemplateDocument", {
        path: data.path,
      });
      await fetch(this.getDownloadUrl, {
        method: "GET",
        responseType: "blob",
      })
        .then((res) => res.blob())
        .then((response) => {
          var fileURL = window.URL.createObjectURL(response);
          const link = document.createElement("a");
          link.href = fileURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      if (this.getDownloadUrl) {
        // window.open(this.getDownloadUrl, "_blank");
      } else {
        this.$notify.error({
          title: "Error",
          message: this.getDownloadError || "Error while downloading",
        });
      }
      this.loading = false;
      this.loadingText = "Loading....";
    },
    async getImgUrlToBase64(url) {
      try {
        const toDataURL = async (url) => {
          const response = await fetch(url);
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const blob = await response.blob();
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          });
        };

        const resultImg = await toDataURL(url);
        return resultImg;
      } catch (error) {
        console.error("Error fetching or converting image:", error);
        return null;
      }
    },
    getSearchPrimaryFields(index, entity) {
      let result = [];
      if (
        entity?.primaryFields?.[index]?.template_id &&
        entity?.primaryFields?.[index]?.key
      ) {
        result = [
          entity?.primaryFields?.[index]?.template_id +
            "." +
            entity?.primaryFields?.[index]?.key,
        ];
      }
      return result;
    },
    getAllTemplateFieldsObject(templates) {
      let templateFieldsObj = {};
      (templates || []).map((eachTemp) => {
        let tempFields = this.getTemplateFieldsInfo(
          eachTemp,
          true,
          false,
          false,
          true
        );
        (tempFields || []).map((field) => {
          templateFieldsObj[field.template_key] = field;
        });
      });
      return templateFieldsObj;
    },
    async updateRelationshipsData(data, template, relationships) {
      let toAssignRelationshipsData = this.prepareRelationshipData(
        template?.sections?.[0]?.fields || [],
        relationships,
        data.entity_data_id,
        null,
        data?.template_data
      );
      if (toAssignRelationshipsData.length) {
        await postAPICall(
          "POST",
          `/entities/${toAssignRelationshipsData[0].parent_entity_id}/relationships-data/assign-fields-data`,
          toAssignRelationshipsData
        );
      }
    },
  },
};
